import { render, staticRenderFns } from "./SelectedFilters.vue?vue&type=template&id=b7f3d388"
import script from "./SelectedFilters.vue?vue&type=script&lang=ts"
export * from "./SelectedFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports